module.exports = __webpack_public_path__ + "static/media/diner_s.89b07da5.jpg";